import ContractManagement from './ContractManagement';

export default ContractManagement;
